import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { Suspense } from "react";
import { makeStyles } from "tss-react/mui";
import LoadingIcon from "@/components/Map/components/LoadingIcon";
import Tabs, { type TabItem } from "@/components/Misc/Tabs";
import Page from "@/components/Page";
import { useRealmRoles } from "@/hooks/Authorization";

const useStyles = makeStyles()((theme) => ({
  tabs: {
    margin: theme.spacing(1),
  },
}));

function SettingsLayout() {
  const { classes } = useStyles();
  const { roles } = useRealmRoles();
  const is_staff = roles.includes("staff");

  const activeTab = useRouterState({
    select: (s) => {
      const pathname = s.location.pathname;
      if (pathname.startsWith("/innstillinger/opplasting")) return "opplasting";
      if (pathname.startsWith("/innstillinger/integrasjon")) return "integrasjon";
      return "brukerinnstillinger";
    },
  });

  const tabs: TabItem[] = [
    {
      value: "brukerinnstillinger",
      label: "Brukerinnstillinger",
      linkOptions: { to: "/innstillinger" },
    },
    {
      value: "opplasting",
      label: is_staff ? "Opplastning av data" : "Opplastet data",
      linkOptions: { to: "/innstillinger/opplasting" },
    },
    {
      value: "integrasjon",
      label: "Integrasjon",
      linkOptions: { to: "/innstillinger/integrasjon" },
    },
  ];

  return (
    <Page contentPadding maxWidth="xl">
      <Tabs className={classes.tabs} selected={activeTab} tabs={tabs} />
      <Suspense fallback={<LoadingIcon />}>
        <Outlet />
      </Suspense>
    </Page>
  );
}

export const Route = createFileRoute("/_auth/innstillinger")({
  component: SettingsLayout,
  beforeLoad: () => ({
    getTitle: () => "Innstillinger",
  }),
});
